import { MerchantResponse } from '@repo/api/endpoints/merchant';

export const getSettingsUrl = (
  data: MerchantResponse['data']['merchantData'],
  platformUrl: string,
) => {
  return data.mvm ? `${platformUrl}verify` : `${platformUrl}merchant/${data.pos}/settings`;
};
